import {useCallback, useState} from 'react'
import useSearchStore from '@app/components/search-section/store/search-store'
import debounce from 'lodash.debounce'

const useSearch = () => {
  const [showSearchBtn, setShowSearchBtn] = useState(true)
  const {setSearchQuery, clearSearch} = useSearchStore()

  const updateSearch = useCallback(
    debounce((value) => {
      setSearchQuery(value)
    }, 200),
    [],
  )

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {value} = e.target
    setShowSearchBtn(value.length <= 0)
    updateSearch(value)
  }

  const resetSearch = () => {
    setShowSearchBtn(true)
    clearSearch()
  }

  return {showSearchBtn, handleSearch, resetSearch}
}

export default useSearch
